import { useMemo } from 'react';
import lightenDarkenColor from '../utils/lightenDarkenColor';
import getColorBasedOnBgColor from '../utils/getColorBasedOnBgColor';
import { COLORS } from '../styles/variables';
import type { VehicleInfo } from '../types';
import {
  COLOR_BASE_BRAND_WHITE,
  COLOR_BASE_BRAND_BLACK,
  COLOR_UI_TERTIARY_DARK,
  COLOR_BASE_GREY_60,
  COLOR_UI_DIVIDER_LIGHT,
  COLOR_BASE_GREY_80,
} from '@audi/audi-ui-design-tokens';

const usePalette = (
  vehicleData: VehicleInfo | undefined,
): {
  backgroundColor: string;
  darkenedBackgroundColor: string;
  textColor: string;
  statusTextColor: string;
  statusBgColor: string;
  popUpBgColor: string;
} => {
  const backgroundColor = vehicleData?.dominantExteriorColor || '#999999';

  const darkenedBackgroundColor = useMemo(
    () => `#${lightenDarkenColor(backgroundColor, -7)}`,
    [backgroundColor],
  );

  const textColor = useMemo(
    () => getColorBasedOnBgColor(backgroundColor, COLOR_BASE_BRAND_WHITE, COLOR_BASE_BRAND_BLACK),
    [backgroundColor],
  );

  const statusTextColor = useMemo(
    () => getColorBasedOnBgColor(backgroundColor, COLOR_UI_TERTIARY_DARK, COLOR_BASE_GREY_60),
    [backgroundColor],
  );

  const statusBgColor = useMemo(
    () => getColorBasedOnBgColor(backgroundColor, COLORS.whiteOpacity, COLOR_UI_DIVIDER_LIGHT),
    [backgroundColor],
  );

  const popUpBgColor = useMemo(
    () => getColorBasedOnBgColor(backgroundColor, COLOR_BASE_BRAND_BLACK, COLOR_BASE_GREY_80),
    [backgroundColor],
  );

  const paletteBag = useMemo(
    () => ({
      backgroundColor,
      darkenedBackgroundColor,
      textColor,
      statusTextColor,
      statusBgColor,
      popUpBgColor,
    }),
    [
      backgroundColor,
      darkenedBackgroundColor,
      popUpBgColor,
      statusBgColor,
      statusTextColor,
      textColor,
    ],
  );

  return paletteBag;
};

export default usePalette;
